import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./SubscribePage.module.css";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { getTokenApi, loginApi, printLogsApi, subscribeApi, getIPApi, getHeaderEnrichmentApi } from "../Http/http";
import Spinner from "../Components/Spinner";

export default function LoginPage({
    serviceName = "Gamers Fusion",
    description = "Unlimited access to premium HTML 5 Games: Action, Adventure, Puzzle, and more!",
    optOutText = "To unsubscribe anytime, reply STOP to 12345 or visit /unsubscribe.",
    providerName = "Rainboo Softmate Pvt Ltd",
}) {

    const parallaxRef = useRef(null);

    // Smooth parallax on scroll (GPU-accelerated)
    useEffect(() => {
        const root = parallaxRef.current;
        if (!root) return;

        const layers = root.querySelectorAll("[data-speed]");
        let ticking = false;

        const onScroll = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                const y = window.scrollY || window.pageYOffset;
                layers.forEach((el) => {
                    const speed = parseFloat(el.getAttribute("data-speed") || "0.2");
                    el.style.transform = `translate3d(0, ${y * speed}px, 0)`;
                });
                ticking = false;
            });
        };

        // Initial position + scroll listener
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [subscribeLoading, setSubscribeLoading] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            if (msisdn?.trim().length > 0) {

                setSubscribeLoading(true);

                let msisdnWithCountryCode = msisdn?.toString().trim().replace(/\D/g, '');

                if (msisdnWithCountryCode.startsWith('0')) {
                    msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
                }

                if (!msisdnWithCountryCode.startsWith('278')) {
                    msisdnWithCountryCode = '278' + msisdnWithCountryCode;
                }


                // let msisdn2 = msisdn;
                // if (!msisdn2.startsWith("278")) {
                //     msisdn2 = "278" + msisdn2;
                // }

                const response = await axios.post(loginApi, {
                    msisdn: msisdnWithCountryCode,
                    ext_ref: extRef,
                });

                console.log(response, 'response...');

                setSubscribeLoading(false);
                Cookies.set('msisdn', msisdnWithCountryCode, { expires: 1 });
                navigate("/home");
            }
            else {
                toast.error("Please Enter the Number!");
                return;
            }

        } catch (error) {
            console.log(error, 'error---');
            setSubscribeLoading(false);

            if (error?.response?.status == 400) {
                toast.error("You are not Subscribed! Please Subscribe First!");
            }
            else if (error?.response?.status === 500) {
                toast.error("Something went wrong on the server. Please try again later.");
            } else {
                console.log(error, 'erro---');
                toast.error("Something Went Wrong!");
            }
        }
    }

    return (
        <>

            <div className={styles.page}>
                {/* Parallax Hero */}
                <div ref={parallaxRef} className={styles.heroWrap}>
                    <div className={`${styles.layer} ${styles.stars}`} data-speed="0.15" />
                    <div className={`${styles.layer} ${styles.pixels}`} data-speed="0.25" />
                    <div className={`${styles.layer} ${styles.planets}`} data-speed="0.35" />
                    <header className={styles.hero}>
                        <div className={styles.brandRow}>
                            <span className={styles.badge}>★</span>
                            <h1 className={styles.title}>
                                {serviceName}
                                <span className={styles.sub}>HTML 5 Gaming Portal</span>
                            </h1>
                        </div>
                        <p className={styles.tagline}>{description}</p>
                        <ul className={styles.perks}>
                            <li>30+ kids games</li>
                            <li>No ads inside portal</li>
                        </ul>
                    </header>
                </div>

                {/* Main Card */}
                <main className={styles.main}>

                    <div className={styles.landingPageBanner}>
                        <img src="/assets/banner.gif" alt="Banner" className={styles.banner} />
                    </div>

                    <section className={styles.card}>

                        <div className={styles.cardHeader}>
                            <h2 className={styles.cardTitle}>Login Now</h2>
                        </div>


                            <input type='number' placeholder='Enter your Number' value={msisdn} onChange={(e) => setMsisdn(e.target.value)}
                                className={styles.input}
                            />

                            <button className={styles.cta} style={{marginTop:'12px'}} id="subscribe_btn" onClick={handleLogin}
                                disabled={subscribeLoading}
                            >
                                {subscribeLoading ? "Loading..." : (
                                    <>
                                        Login 
                                    </>
                                )}
                            </button>

                        <div className={styles.center_button}>
                            <button className={styles.loginLink} onClick={() => navigate(`/subscribe?ext_id=${extRef}`)}>
                                New User, Subscribe
                            </button>

                        </div>

                    </section>

                    <section className={styles.infoGrid}>

                        <article className={styles.infoCard}>
                            <h4>Terms & Conditions</h4>
                            <ul className={styles.features}>
                                <li>
                                    The service cost is KSH 15/day.
                                </li>
                                <li>
                                    Your Subscription will be renewed at KSH 15/day, automatically until you unsubscribe.
                                </li>
                                <li>
                                    You can unsubscribe from the service anytime, by dialling USSD code *xxx# or deactivating from the portal.
                                </li>
                                <li>
                                    All data-enabled features & Smartphone users can enjoy full service.
                                </li>
                                <li>
                                    Customer can access the content at any time during the subscription validity period.
                                </li>
                            </ul>
                        </article>

                        <article className={styles.infoCard}>
                            <h4>What you get</h4>
                            <ul className={styles.features}>
                                <li>Unlimited access to the kids games</li>
                                <li>30+ Games — play instantly</li>
                                <li>Top Categories — action, adventure, puzzle, arcade and more</li>
                                <li>No Ads — play instantly</li>
                            </ul>
                        </article>



                        <article className={styles.infoCard}>
                            <h4>Provider</h4>
                            <p>
                                Service by <strong>{providerName}</strong>.
                            </p>
                        </article>
                    </section>
                </main>

                <footer className={styles.footer}>
                    <p>
                        © {new Date().getFullYear()} {providerName}. All rights reserved.
                    </p>
                </footer>
            </div>

            {loading &&
                <div className={styles.full_screen_loader_container}>
                    <Spinner />
                    <p className={styles.loader_text}>Loading Please Wait...</p>
                </div>
            }
        </>
    );
}
